import TransferBahanProduksiAsetApi from "./TransferBahanProduksiAsetApi";

export default TransferBahanProduksiAsetApi;
